import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_quiz_checkable_text_question = _resolveComponent("quiz-checkable-text-question");
  const _component_quiz_blanks_question = _resolveComponent("quiz-blanks-question");
  const _component_quiz_pairs_matching_question = _resolveComponent("quiz-pairs-matching-question");
  const _component_quiz_sorting_question = _resolveComponent("quiz-sorting-question");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["simple-quiz-container", [{
      'quiz-result-container': _ctx.isResultMode,
      'success-results': _ctx.answersApprovalState
    }]])
  }, [_ctx.question ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.isCheckableQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_checkable_text_question, {
    key: 0,
    class: "simple-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    selected: _ctx.userAnswers(_ctx.question),
    "right-answer": _ctx.rightAnswer,
    "is-result-mode": _ctx.isResultMode,
    "display-answers-validation-alert": _ctx.shouldDisplayAnswerValidationAlert,
    "answers-validation-state": _ctx.answersApprovalState,
    onSelectionChange: _ctx.onSelectionChange
  }, null, 8, ["question", "question-custom-label", "selected", "right-answer", "is-result-mode", "display-answers-validation-alert", "answers-validation-state", "onSelectionChange"])) : _ctx.isBlanksQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_blanks_question, {
    key: 1,
    class: "simple-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-blanks-answers": _ctx.userBlanksAnswers,
    "is-result-mode": _ctx.isResultMode,
    "display-answers-validation-alert": _ctx.shouldDisplayAnswerValidationAlert,
    "answers-validation-state": _ctx.answersApprovalState,
    onBlankAnswerUpdate: _ctx.onBlankAnswerUpdate
  }, null, 8, ["question", "question-custom-label", "user-blanks-answers", "is-result-mode", "display-answers-validation-alert", "answers-validation-state", "onBlankAnswerUpdate"])) : _ctx.isPairsMatchingQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_pairs_matching_question, {
    key: 2,
    class: "simple-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-pairs-matching": _ctx.userPairsMatching,
    "is-result-mode": _ctx.isResultMode,
    "display-answers-validation-alert": _ctx.shouldDisplayAnswerValidationAlert,
    "answers-validation-state": _ctx.answersApprovalState,
    onUserPairMatchingUpdate: _ctx.onPairMatchingUpdate
  }, null, 8, ["question", "question-custom-label", "user-pairs-matching", "is-result-mode", "display-answers-validation-alert", "answers-validation-state", "onUserPairMatchingUpdate"])) : _ctx.isSortingQuestion(_ctx.question) ? (_openBlock(), _createBlock(_component_quiz_sorting_question, {
    key: 3,
    class: "simple-quiz-question",
    question: _ctx.question,
    "question-custom-label": _ctx.getQuestionLabel(_ctx.question),
    "user-items-sorting": _ctx.userItemsSorting,
    "is-result-mode": _ctx.isResultMode,
    "display-answers-validation-alert": _ctx.shouldDisplayAnswerValidationAlert,
    "answers-validation-state": _ctx.answersApprovalState,
    onUserItemsSortingUpdate: _ctx.onItemsSortingUpdate
  }, null, 8, ["question", "question-custom-label", "user-items-sorting", "is-result-mode", "display-answers-validation-alert", "answers-validation-state", "onUserItemsSortingUpdate"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)], 2);
}